import { OrderList } from "primereact/orderlist";
import styled from "styled-components";
import { flex } from "@styled-system/patterns";

export const OrderListWithoutControls = styled(OrderList)`
	.p-orderlist-controls {
		display: none;
	}
`;

export const buttonContainerClass = flex({
	gap: "4",
	marginBottom: "8",
});
